/*
 * MAIN SCRIPT
 * DON'T WRITE FUNCTION HERE, ONLY CALL THEM
 *
 * **/
// document event listeners
let isDocumentScrolled = false;
document.addEventListener('scroll', () => {
    //assure to trigger just once
    if (!isDocumentScrolled) {
        isDocumentScrolled = true;
        initRecaptcha();
    }
});
if (document.readyState !== 'loading' && document.readyState !== 'interactive') {
    console.log('document is already ready, just execute code here');
    initFormsValidation();
    initModalResponse();
    initIubendaProof();
    initLoadMore();
    // initMegaMenu();
    // initSwitchLanguage();
    initModalVideo();
    initOpenCloseAccordion();
    jsLazyLoadImages();
    initBackgroundColorWallpaperImageAndText();
    initNumberingTechnicalSpecification();
    initMasonry();
    initPageSlider();
    initVideo();
    initRadarChart();
    initConfiguratorSlider();
    initSimpleHeading();
    initProductHeading();
}
else {
    document.addEventListener('DOMContentLoaded', function () {
        console.log('document was not ready, place code here');
        initFormsValidation();
        initModalResponse();
        initIubendaProof();
        initLoadMore();
        // initMegaMenu();
        // initSwitchLanguage();
        initModalVideo();
        initOpenCloseAccordion();
        jsLazyLoadImages();
        initBackgroundColorWallpaperImageAndText();
        initNumberingTechnicalSpecification();
        initMasonry();
        initPageSlider();
        initVideo();
        initRadarChart();
        initConfiguratorSlider();
        initSimpleHeading();
        initProductHeading();
    });
}
document.onreadystatechange = function () {
    if (document.readyState == "complete") {
        console.log('document ready state is complete');
        initFormsValidation();
        initModalResponse();
        initIubendaProof();
        initLoadMore();
        initMegaMenu();
        initSwitchLanguage();
        initModalVideo();
        initOpenCloseAccordion();
        jsLazyLoadImages();
        initBackgroundColorWallpaperImageAndText();
        initNumberingTechnicalSpecification();
        initMasonry();
        initPageSlider();
        initVideo();
        initRadarChart();
        initConfiguratorSlider();
        initSimpleHeading();
        initProductHeading();
    }
};
